export const ProfileStore = {
    state: () => ({
        data: {},
        isLoaded: false,
    }),
    mutations: {
        setProfile: function(state, profile) {
            if (profile) {
                state.data = profile;
                state.isLoaded = true;
            }
        },
        updatePoints: function(state, point) {
            state.data.updated_points.points = point;
        },
    },
    getters: {
        getProfile: function(state) {
            return state.data;
        },
        isProfileLoaded: function(state) {
            console.log(state.isLoaded);
            return state.isLoaded;
        }
    },
    // actions: {
    //     increment: function(context) {
    //         context.commit('increment');
    //     },
    // },
};
